// packages/api-client/src/services/public/investmentsService.ts

import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { ServiceResponse } from '@dopomogai/types';
import type { InvestOfferingsListResponse, InvestOfferingResponse } from '@dopomogai/types';

const PREFIX = '/invest';

export interface ListOfferingsParams {
  limit?: number;
  offset?: number;
}

export const investmentsService = {
  listOfferings: (params?: ListOfferingsParams): ServiceResponse<InvestOfferingsListResponse> => {
    const qs = new URLSearchParams();
    if (typeof params?.limit === 'number') qs.set('limit', String(params.limit));
    if (typeof params?.offset === 'number') qs.set('offset', String(params.offset));
    const url = qs.toString() ? `${PREFIX}/offerings?${qs}` : `${PREFIX}/offerings`;

    return getApiClient()
      .get<InvestOfferingsListResponse>(url)
      .then(res => res.data)
      .catch(err => handleApiError(err, 'listing investment offerings'));
  },

  getOffering: (agentId: string): ServiceResponse<InvestOfferingResponse> => {
    return getApiClient()
      .get<InvestOfferingResponse>(`${PREFIX}/agents/${encodeURIComponent(agentId)}/offering`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `fetching offering for agent '${agentId}'`));
  },
};


